import { createContext } from 'react'

export const SavedPropertiesContext = createContext({
  savedIds: [],
  isSaved: () => false,
  toggleSaved: () => {},
  save: () => {},
  remove: () => {},
})
